export enum Distance {
  ZeroToThree = '0-3',
  ThreeToEight = '3-8',
  EightToFifteen = '8-15',
  FifteenPlus = '15+',
} 